"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSectionEnabled = exports.enableDisableSection = void 0;
const src_1 = require("..");
function enableDisableSection(type, show) {
    const methodsKeys = Object.keys(src_1.showPaymentMethods);
    const onAction = (0, src_1.getOnAction)();
    if (methodsKeys.includes(type)) {
        src_1.showPaymentMethods[type] = show;
        if (onAction) {
            onAction(src_1.actionTypes.ENABLE_DISABLE_SECTION, { show: isSectionEnabled() });
        }
    }
}
exports.enableDisableSection = enableDisableSection;
function isSectionEnabled() {
    return Object.values(src_1.showPaymentMethods).some(value => value === true);
}
exports.isSectionEnabled = isSectionEnabled;
